import { isCompanyWorkspaceEnabled } from '../../config/companyWorkspace';

export const NAV_ZONES = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  OFFCANVAS: 'offcanvas',
};

export const NAV_AUTH = {
  ANY: 'any',
  USER: 'user',
  GUEST: 'guest',
};

export const navItems = [
  {
    id: 'home',
    label: 'Головна',
    to: '/feed',
    iconClass: 'fa-solid fa-house',
    auth: NAV_AUTH.ANY,
    zones: [NAV_ZONES.DESKTOP],
  },
  {
    id: 'search',
    label: 'Пошук',
    to: '/search',
    iconClass: 'fa-solid fa-magnifying-glass',
    auth: NAV_AUTH.ANY,
    zones: [NAV_ZONES.DESKTOP],
    // Enabled in R2 — RealtySearchScreen landed at /search.
  },
  {
    id: 'users',
    label: 'Користувачі',
    to: '/users',
    iconClass: 'fa-solid fa-users',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'dashboard',
    label: 'Огляд',
    to: '/dashboard',
    iconClass: 'fa-solid fa-chart-line',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'clients',
    label: 'Клієнти CRM',
    to: '/clients',
    iconClass: 'fa-solid fa-address-book',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
    // disabled: CRM module not implemented yet
    // disabled: true,
  },
  {
    id: 'tasks',
    label: 'Задачі',
    to: '/tasks',
    iconClass: 'fa-solid fa-list-check',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'deals',
    label: 'Угоди',
    to: '/deals',
    iconClass: 'fa-solid fa-handshake',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'finance',
    label: 'Мої фінанси',
    to: '/finance',
    iconClass: 'fa-solid fa-wallet',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'company',
    label: 'Моя компанія',
    to: '/companies/mine',
    iconClass: 'fa-solid fa-building',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
  },
  {
    id: 'add',
    label: 'Додати',
    to: '/add',
    iconClass: 'fa-solid fa-circle-plus',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP],
    // Enabled in RIC-1 — RealtyCreateScreen wizard landed at /add.
  },
  {
    id: 'messenger',
    label: 'Повідомлення',
    to: '/chats',
    iconClass: 'fa-solid fa-envelope',
    auth: NAV_AUTH.USER,
    badgeKey: 'unreadChats',
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item-message' },
  },
  {
    id: 'notifications',
    label: 'Сповіщення',
    to: '/notifications',
    iconClass: 'fa-solid fa-bell',
    auth: NAV_AUTH.USER,
    badgeKey: 'unreadNotifications',
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.MOBILE, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'p-nav-item__md-none' },
    // disabled: no notifications screen yet
    // disabled: true,
  },
  {
    id: 'profile',
    label: 'Профіль',
    to: '/profile',
    iconClass: 'fa-solid fa-user',
    auth: NAV_AUTH.USER,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    avatarKey: 'userImage',
  },
  {
    id: 'faq',
    label: 'FAQ — довідник',
    to: '/faq',
    iconClass: 'fa-solid fa-circle-question',
    auth: NAV_AUTH.ANY,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
    extraClassName: { desktop: 'd-none d-lg-flex' },
    // disabled: no FAQ screen yet
    disabled: true,
  },
  {
    id: 'login',
    label: 'Увійти',
    to: '/login',
    iconClass: 'fa-solid fa-arrow-right-to-bracket',
    auth: NAV_AUTH.GUEST,
    zones: [NAV_ZONES.DESKTOP, NAV_ZONES.OFFCANVAS],
  },
];

function passesAuth(item, isAuthed) {
  if (item.auth === NAV_AUTH.ANY) return true;
  if (item.auth === NAV_AUTH.USER) return isAuthed;
  if (item.auth === NAV_AUTH.GUEST) return !isAuthed;
  return false;
}

function resolveExtraClassName(extraClassName, zone) {
  if (!extraClassName) return undefined;
  if (typeof extraClassName === 'string') return extraClassName;
  return extraClassName[zone];
}

export function getNavItems({ zone, isAuthed = false, badges = {} }) {
  const companyWorkspaceEnabled = isCompanyWorkspaceEnabled();
  return navItems
    .filter((item) => !item.disabled)
    .filter((item) => item.zones.includes(zone))
    .filter((item) => passesAuth(item, isAuthed))
    .filter((item) => companyWorkspaceEnabled || item.id !== 'company')
    .map((item) => ({
      ...item,
      badge: item.badgeKey ? badges[item.badgeKey] : undefined,
      extraClassName: resolveExtraClassName(item.extraClassName, zone),
    }));
}
